<template>
    <div class="progress-bar-container">
      <div class="progress-bar-fill" :style="{ width: progress + '%' }"></div>
      <div class="progress-bar-label">{{ progress }}%</div>
    </div>
</template>
  
  <script>
  export default {
    name: "ProgressBar",
    props: {
      progress: {
        type: Number,
        required: true,
        validator(value) {
          return value >= 0 && value <= 100;
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .progress-bar-container {
    width: 100%;
    height: 20px;
    border-radius: 5px;
    background-color: #e0e0e0;
    position: relative;
    overflow: hidden;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 10px;
  }
  
  .progress-bar-fill {
    height: 100%;
    background-color: #6b8e23; /* Green Color */
    transition: width 0.5s ease-in-out;
  }
  
  .progress-bar-label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: .75rem;
  }
  </style>
  